'use strict';

var _regeneratorRuntime = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _wrapAsyncGenerator = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncGeneratorDelegate = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

var _asyncIterator = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var normaliseInput = require('ipfs-core-utils/src/files/normalise-input');

var toStream = require('./to-stream');

var _require = require('nanoid'),
    nanoid = _require.nanoid;

var modeToString = require('../lib/mode-to-string');

var mtimeToObject = require('../lib/mtime-to-object');

var merge = require('merge-options').bind({
  ignoreUndefined: true
});

function multipartRequest() {
  return _multipartRequest.apply(this, arguments);
}

function _multipartRequest() {
  _multipartRequest = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    var source,
        abortController,
        headers,
        boundary,
        streamFiles,
        _streamFiles,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _streamFiles = function _ref2() {
              _streamFiles = _wrapAsyncGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee(source) {
                var index, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, _value2, content, path, mode, mtime, fileSuffix, type, _mtimeToObject, secs, nsecs;

                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        index = 0;
                        _iteratorNormalCompletion = true;
                        _didIteratorError = false;
                        _context.prev = 4;
                        _iterator = _asyncIterator(normaliseInput(source));

                      case 6:
                        _context.next = 8;
                        return _awaitAsyncGenerator(_iterator.next());

                      case 8:
                        _step = _context.sent;
                        _iteratorNormalCompletion = _step.done;
                        _context.next = 12;
                        return _awaitAsyncGenerator(_step.value);

                      case 12:
                        _value = _context.sent;

                        if (_iteratorNormalCompletion) {
                          _context.next = 45;
                          break;
                        }

                        _value2 = _value, content = _value2.content, path = _value2.path, mode = _value2.mode, mtime = _value2.mtime;
                        fileSuffix = '';
                        type = content ? 'file' : 'dir';

                        if (!(index > 0)) {
                          _context.next = 21;
                          break;
                        }

                        _context.next = 20;
                        return '\r\n';

                      case 20:
                        fileSuffix = "-".concat(index);

                      case 21:
                        _context.next = 23;
                        return "--".concat(boundary, "\r\n");

                      case 23:
                        _context.next = 25;
                        return "Content-Disposition: form-data; name=\"".concat(type).concat(fileSuffix, "\"; filename=\"").concat(encodeURIComponent(path), "\"\r\n");

                      case 25:
                        _context.next = 27;
                        return "Content-Type: ".concat(content ? 'application/octet-stream' : 'application/x-directory', "\r\n");

                      case 27:
                        if (!(mode !== null && mode !== undefined)) {
                          _context.next = 30;
                          break;
                        }

                        _context.next = 30;
                        return "mode: ".concat(modeToString(mode), "\r\n");

                      case 30:
                        if (!(mtime != null)) {
                          _context.next = 37;
                          break;
                        }

                        _mtimeToObject = mtimeToObject(mtime), secs = _mtimeToObject.secs, nsecs = _mtimeToObject.nsecs;
                        _context.next = 34;
                        return "mtime: ".concat(secs, "\r\n");

                      case 34:
                        if (!(nsecs != null)) {
                          _context.next = 37;
                          break;
                        }

                        _context.next = 37;
                        return "mtime-nsecs: ".concat(nsecs, "\r\n");

                      case 37:
                        _context.next = 39;
                        return '\r\n';

                      case 39:
                        if (!content) {
                          _context.next = 41;
                          break;
                        }

                        return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(content), _awaitAsyncGenerator), "t0", 41);

                      case 41:
                        index++;

                      case 42:
                        _iteratorNormalCompletion = true;
                        _context.next = 6;
                        break;

                      case 45:
                        _context.next = 51;
                        break;

                      case 47:
                        _context.prev = 47;
                        _context.t1 = _context["catch"](4);
                        _didIteratorError = true;
                        _iteratorError = _context.t1;

                      case 51:
                        _context.prev = 51;
                        _context.prev = 52;

                        if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                          _context.next = 56;
                          break;
                        }

                        _context.next = 56;
                        return _awaitAsyncGenerator(_iterator.return());

                      case 56:
                        _context.prev = 56;

                        if (!_didIteratorError) {
                          _context.next = 59;
                          break;
                        }

                        throw _iteratorError;

                      case 59:
                        return _context.finish(56);

                      case 60:
                        return _context.finish(51);

                      case 61:
                        _context.next = 66;
                        break;

                      case 63:
                        _context.prev = 63;
                        _context.t2 = _context["catch"](0);
                        // workaround for https://github.com/node-fetch/node-fetch/issues/753
                        abortController.abort(_context.t2);

                      case 66:
                        _context.prev = 66;
                        _context.next = 69;
                        return "\r\n--".concat(boundary, "--\r\n");

                      case 69:
                        return _context.finish(66);

                      case 70:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[0, 63, 66, 70], [4, 47, 51, 61], [52,, 56, 60]]);
              }));
              return _streamFiles.apply(this, arguments);
            };

            streamFiles = function _ref(_x) {
              return _streamFiles.apply(this, arguments);
            };

            source = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : '';
            abortController = _args2.length > 1 ? _args2[1] : undefined;
            headers = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
            boundary = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : "-----------------------------".concat(nanoid());
            _context2.t0 = merge(headers, {
              'Content-Type': "multipart/form-data; boundary=".concat(boundary)
            });
            _context2.next = 9;
            return toStream(streamFiles(source));

          case 9:
            _context2.t1 = _context2.sent;
            return _context2.abrupt("return", {
              headers: _context2.t0,
              body: _context2.t1
            });

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _multipartRequest.apply(this, arguments);
}

module.exports = multipartRequest;